import { createLazyApiInstance } from '../utils/axiosSetup';

// Create lazy-loaded axios instance (waits for AuthContext callbacks to be registered)
const api = createLazyApiInstance();

// Auth service
const authService = {
  // Login
  login: async (email, password) => {
    const response = await api.post('/auth/login', {
      email,
      password
    });
    return response.data;
  },

  // Logout
  logout: async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    const response = await api.post('/auth/logout', { refreshToken });
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    return response.data;
  },

  // Get current user profile
  getProfile: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  // Setup 2FA
  setup2FA: async () => {
    const response = await api.post('/auth/2fa/setup');
    return response.data;
  },

  // Enable 2FA
  enable2FA: async (token, secret) => {
    const response = await api.post('/auth/2fa/enable', { token, secret });
    return response.data;
  },

  // Verify 2FA during login
  verify2FA: async (token, tempToken) => {
    const response = await api.post('/auth/2fa/verify', { token, tempToken });
    return response.data;
  },

  // Disable 2FA
  disable2FA: async (password) => {
    const response = await api.post('/auth/2fa/disable', { password });
    return response.data;
  },

  // Refresh token
  refresh: async (refreshToken) => {
    const response = await api.post('/auth/refresh', { refreshToken });
    return response.data;
  }
};

export default authService;
